export default "__VITE_ASSET__BMrbFvKo__"